module.exports = __webpack_public_path__ + "img/Wishlist.3c18e55a.png";